<div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">
    <div id="login-intro" fxFlex fxHide fxShow.gt-xs>
        <div class="logo" [@animate]="{ value: '*', params: { scale: '0.2' } }">
            <img *ngIf="!logo" src="assets/images/logos/clinic_all.png" />
            <img *ngIf="logo" [src]="logo"/>
        </div>


        <div class="title" [@animate]="{ value: '*', params: { delay: '50ms', y: '25px' } }">
            Bem vindo!
        </div>

        <div class="description" [@animate]="{ value: '*', params: { delay: '100ms', y: '25px' } }">
            AGENDAMENTO ONLINE PACIENTE
        </div>
    </div>

    <div id="login-form-wrapper" fusePerfectScrollbar
        [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }">

        <div id="login-form">

            <div *ngIf="progessbar">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                <br>
            </div>

            <div class="logo" fxHide.gt-xs>
                <img *ngIf="!logo" src="assets/images/logos/clinic_all.png">
                <img *ngIf="logo" [src]="logo">
            </div>
            <div class="title">Portal do Paciente</div>

            <form name="loginForm" [formGroup]="loginForm" novalidate (ngSubmit)="autenticate()">
                <mat-form-field appearance="outline">
                    <mat-label>CPF</mat-label>
                    <input matInput formControlName="cpf" mask='000.000.000-00' />
                    <mat-icon matSuffix class="secondary-text">person</mat-icon>
                    <mat-error *ngIf="loginForm.get('cpf').hasError('required')">
                        CPF é obrigatório
                    </mat-error>
                    <mat-error *ngIf="
                            !loginForm.get('cpf').hasError('required') &&
                            loginForm.get('cpf').hasError('cpf')
                        ">
                        CPF é obrigatório
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Data de nascimento</mat-label>
                    <input matInput type="text" formControlName="dataNascimento" mask='d0/M0/0000'
                        [dropSpecialCharacters]="false" placeholder="Ex.: dd/mm/aaaa" />
                    <mat-icon matSuffix class="secondary-text">today</mat-icon>
                    <mat-error> Data de nascimento é obrigatório </mat-error>
                </mat-form-field>

                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center"></div>

                <button mat-button color="accent" type="button" [disabled]="button"
                    (click)="unregisteredSchedule()">
                    Não tem cadastro clique aqui
                </button>

                <button mat-raised-button color="accent" class="submit-button" aria-label="LOGIN"
                [disabled]="loginForm.invalid"  type="submit">
                    LOGIN
                </button>
            </form>
        </div>
    </div>
</div>
